// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:host {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: stretch;
}

.user-section {
  padding: 1rem;
  background-color: #f9fafb;
  min-height: 100vh;
  /* Responsive */
}
.user-section .top-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  gap: 1rem;
}
.user-section .top-actions .search-box {
  position: relative;
  flex: 1 1 250px;
  max-width: 400px;
}
.user-section .top-actions .search-box input {
  width: 100%;
  padding: 0.6rem 1rem 0.6rem 2.5rem;
  border-radius: 10px;
  border: 1px solid #ccc;
  font-size: 0.95rem;
  background: #fff;
  transition: all 0.3s ease;
}
.user-section .top-actions .search-box input:focus {
  border-color: #1571b9;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
  outline: none;
}
.user-section .top-actions .search-box .search-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #999;
}
.user-section .top-actions .action-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.user-section .top-actions .action-buttons .btn {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.5rem 0.9rem;
  border: none;
  border-radius: 8px;
  font-size: 0.9rem;
  cursor: pointer;
  color: #1571b9;
  transition: all 0.3s ease;
}
.user-section .top-actions .action-buttons .btn.primary {
  background: #fff;
}
.user-section .top-actions .action-buttons .btn.primary:hover {
  background: #1571b9;
  color: #fff;
}
.user-section .top-actions .action-buttons .btn.info {
  background: #fff;
}
.user-section .top-actions .action-buttons .btn.info:hover {
  background: #1571b9;
  color: #fff;
}
.user-section .top-actions .action-buttons .btn.success {
  background: #fff;
}
.user-section .top-actions .action-buttons .btn.success:hover {
  background: #1571b9;
  color: #fff;
}
.user-section .top-actions .action-buttons .btn i {
  font-size: 1rem;
}
.user-section .table-card {
  overflow-x: auto;
}
.user-section .user-table {
  min-width: 800px;
}
.user-section .table-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  overflow-x: auto;
  height: 70vh;
  margin-bottom: 10px;
}
.user-section .table-card .user-table {
  width: 100%;
  border-collapse: collapse;
}
.user-section .table-card .user-table th,
.user-section .table-card .user-table td {
  padding: 0.75rem;
  text-align: left;
  border-bottom: 1px solid #eaeaea;
  white-space: nowrap;
}
.user-section .table-card .user-table thead {
  background: #f1f3f5;
}
.user-section .table-card .user-table thead th {
  font-weight: 600;
  font-size: 0.9rem;
  color: #333;
}
.user-section .table-card .user-table tbody tr:hover {
  background: #f8f9fa;
}
.user-section .table-card .user-table tbody .no-record {
  text-align: center;
  color: #888;
  font-style: italic;
}
.user-section .table-card .user-table .status {
  padding: 0.3rem 0.6rem;
  border-radius: 8px;
  font-size: 0.85rem;
  font-weight: 500;
}
.user-section .table-card .user-table .status.active {
  background: #d4edda;
  color: #155724;
}
.user-section .table-card .user-table .status.inactive {
  background: #f8d7da;
  color: #721c24;
}
.user-section .table-card .user-table .actions {
  display: flex;
  gap: 0.4rem;
}
.user-section .table-card .user-table .actions .icon-btn {
  background: none;
  border: none;
  padding: 0.3rem;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
}
.user-section .table-card .user-table .actions .icon-btn i {
  font-size: 1rem;
}
.user-section .table-card .user-table .actions .icon-btn.success {
  color: #28a745;
}
.user-section .table-card .user-table .actions .icon-btn.success:hover {
  background: rgba(40, 167, 69, 0.1);
}
.user-section .table-card .user-table .actions .icon-btn.warning {
  color: #1571b9;
}
.user-section .table-card .user-table .actions .icon-btn.warning:hover {
  background: rgba(21, 114, 185, 0.212);
}
.user-section .table-card .user-table .actions .icon-btn.danger {
  color: #dc3545;
}
.user-section .table-card .user-table .actions .icon-btn.danger:hover {
  background: rgba(220, 53, 69, 0.15);
}
.user-section .pagination-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1.25rem;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  font-family: "Inter", sans-serif;
}
.user-section .pagination-container .pagination-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}
.user-section .pagination-container .pagination-controls ::ng-deep .ngx-pagination {
  margin: 0;
  list-style: none;
  padding: 0;
  display: flex;
  align-items: center;
}
.user-section .pagination-container .pagination-controls ::ng-deep .ngx-pagination .small-screen {
  display: none;
}
.user-section .pagination-container .pagination-controls ::ng-deep .ngx-pagination li {
  display: inline-flex;
  align-items: center;
  margin: 0 4px;
  height: 35px;
}
.user-section .pagination-container .pagination-controls ::ng-deep .ngx-pagination li a {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
  font-size: 0.9rem;
  color: #374151;
  background: #f9fafb;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  transition: all 0.2s ease;
}
.user-section .pagination-container .pagination-controls ::ng-deep .ngx-pagination li a:hover {
  background: #e5e7eb;
  border-color: #9ca3af;
}
.user-section .pagination-container .pagination-controls ::ng-deep .ngx-pagination .current {
  background: linear-gradient(90deg, #2563eb, #1d4ed8);
  color: #fff;
  border-radius: 8px;
  padding: 6px 12px;
}
.user-section .pagination-container .pagination-controls ::ng-deep .ngx-pagination .disabled {
  opacity: 0.5;
  pointer-events: none;
}
.user-section ::ng-deep .pagination-previous,
.user-section ::ng-deep .pagination-next,
.user-section ::ng-deep .pagination-link,
.user-section ::ng-deep .pagination-ellipsis {
  border: none !important;
  padding-top: 0 !important;
}
@media (max-width: 768px) {
  .user-section .top-actions {
    flex-direction: row;
    align-items: stretch;
  }
  .user-section .action-buttons {
    justify-content: space-between;
  }
  .user-section .user-table {
    font-size: 0.85rem;
  }
  .user-section .icon-btn i {
    font-size: 0.9rem;
  }
}

textarea {
  width: 100%;
  padding: 0.6rem;
  border: 1px solid #ccc;
  border-radius: 0.5rem;
  transition: all 0.3s;
}
textarea:focus {
  border-color: #1571b9;
  box-shadow: 0 0 0 2px rgba(50, 115, 220, 0.2);
  outline: none;
}

.custom-modal {
  position: fixed;
  inset: 0;
  display: none;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.custom-modal.is-active {
  display: flex;
}
.custom-modal .custom-modal-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
}
.custom-modal .custom-modal-container {
  position: relative;
  z-index: 2;
  background: #fff;
  border-radius: 1rem;
  width: 90%;
  max-width: 800px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
  overflow-y: auto;
  max-height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 1rem 1.5rem;
}
@media (max-width: 600px) {
  .custom-modal .custom-modal-container {
    width: 95%;
    padding: 1rem;
  }
}
.custom-modal .custom-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  padding-bottom: 0.5rem;
  order: 0;
}
.custom-modal .custom-modal-header h2 {
  font-size: 1.3rem;
  font-weight: 600;
}
.custom-modal .custom-modal-header .close-btn {
  background: none;
  border: none;
  font-size: 1.2rem;
  cursor: pointer;
  color: #666;
}
.custom-modal .custom-modal-header .close-btn:hover {
  color: #000;
}
.custom-modal .custom-modal-body {
  margin-top: 1rem;
  flex: 1;
  overflow-y: auto;
}
.custom-modal .form-grid {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.custom-modal .form-grid .input-row {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: flex-start;
}
.custom-modal .form-grid .input-row .input-group {
  flex: 1;
  min-width: 200px;
  display: flex;
  flex-direction: column;
}
.custom-modal .form-grid .input-row .input-group label {
  font-weight: 500;
  display: block;
  margin-bottom: 0.4rem;
}
.custom-modal .form-grid .input-row .input-group label span {
  color: #ff4757;
}
.custom-modal .form-grid .input-row .input-group input,
.custom-modal .form-grid .input-row .input-group select {
  width: 100%;
  padding: 0.6rem;
  border: 1px solid #ccc;
  border-radius: 0.5rem;
  transition: all 0.3s;
}
.custom-modal .form-grid .input-row .input-group input:focus,
.custom-modal .form-grid .input-row .input-group select:focus {
  border-color: #1571b9;
  box-shadow: 0 0 0 2px rgba(50, 115, 220, 0.2);
  outline: none;
}
.custom-modal .form-grid .input-row .input-group form-validation {
  display: block;
  margin-top: 0.25rem;
  min-height: 1.2rem;
}
.custom-modal .form-grid .input-row.full-width {
  width: 100%;
}
.custom-modal .form-grid .profile-section {
  display: flex;
  justify-content: center;
  align-items: center;
}
.custom-modal .form-grid .profile-section .profile-wrapper {
  position: relative;
  text-align: center;
}
.custom-modal .form-grid .profile-section .profile-wrapper .profile-image {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #ddd;
  margin-bottom: 0.5rem;
}
.custom-modal .form-grid .profile-section .profile-wrapper .profile-action {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
}
.custom-modal .form-grid .profile-section .profile-wrapper .profile-action .file-label {
  cursor: pointer;
  color: #1571b9;
  font-size: 1rem;
}
.custom-modal .form-grid .profile-section .profile-wrapper .profile-action .remove-btn {
  background: none;
  border: none;
  color: #ff4757;
  cursor: pointer;
  font-size: 0.9rem;
}
.custom-modal .custom-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  border-top: 1px solid #eee;
  padding-top: 0.8rem;
}
.custom-modal .custom-modal-footer .primary-btn {
  background-color: #1571b9;
  color: #fff;
  border: none;
  border-radius: 0.5rem;
  padding: 0.6rem 1.4rem;
  cursor: pointer;
  transition: 0.3s;
}
.custom-modal .custom-modal-footer .primary-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.custom-modal .custom-modal-footer .primary-btn:hover:not(:disabled) {
  background-color: #1571b9;
}
.custom-modal .custom-modal-footer .cancel-btn {
  background-color: #f5f5f5;
  color: #333;
  border: none;
  border-radius: 0.5rem;
  padding: 0.6rem 1.4rem;
  cursor: pointer;
}
.custom-modal .custom-modal-footer .cancel-btn:hover {
  background-color: #eaeaea;
}

.user-bulk-upload-modal {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
}
.user-bulk-upload-modal .modal-overlay {
  position: absolute;
  inset: 0;
}
.user-bulk-upload-modal .modal-content {
  position: relative;
  background: #fff;
  border-radius: 1rem;
  max-width: 700px;
  width: 90%;
  padding: 2rem;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  z-index: 10;
  animation: scaleIn 0.25s ease;
  height: 70vh;
}
@keyframes scaleIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
.user-bulk-upload-modal .modal-content .close-btn {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: transparent;
  border: none;
  font-size: 1.2rem;
  color: #666;
  cursor: pointer;
  transition: color 0.2s ease;
}
.user-bulk-upload-modal .modal-content .close-btn:hover {
  color: #000;
}
.user-bulk-upload-modal .modal-content .bulk-container {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 1.5rem;
  max-width: 1000px;
  margin: 0 auto;
  /* Responsive Design */
}
.user-bulk-upload-modal .modal-content .bulk-container .upload-card,
.user-bulk-upload-modal .modal-content .bulk-container .table-card {
  background: #fff;
  border-radius: 1rem;
  padding: 2rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease-in-out;
}
.user-bulk-upload-modal .modal-content .bulk-container .upload-card:hover,
.user-bulk-upload-modal .modal-content .bulk-container .table-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.1);
}
.user-bulk-upload-modal .modal-content .bulk-container .section-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 0.5rem;
}
.user-bulk-upload-modal .modal-content .bulk-container .section-desc {
  color: #666;
  margin-bottom: 1rem;
}
.user-bulk-upload-modal .modal-content .bulk-container .upload-guidelines {
  list-style: disc;
  padding-left: 1.5rem;
  color: #555;
  margin-bottom: 1.5rem;
}
.user-bulk-upload-modal .modal-content .bulk-container .upload-guidelines li {
  margin-bottom: 0.4rem;
}
.user-bulk-upload-modal .modal-content .bulk-container .upload-guidelines .link {
  color: #0077cc;
  font-weight: 600;
  cursor: pointer;
}
.user-bulk-upload-modal .modal-content .bulk-container .upload-guidelines .link:hover {
  text-decoration: underline;
}
.user-bulk-upload-modal .modal-content .bulk-container .upload-actions,
.user-bulk-upload-modal .modal-content .bulk-container .table-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: flex-end;
  margin-top: 1.5rem;
}
.user-bulk-upload-modal .modal-content .bulk-container .btn {
  border: none;
  border-radius: 0.5rem;
  padding: 0.6rem 1.2rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.25s ease;
}
.user-bulk-upload-modal .modal-content .bulk-container .btn.btn-primary {
  background-color: #0077cc;
  color: #fff;
}
.user-bulk-upload-modal .modal-content .bulk-container .btn.btn-primary:hover {
  background-color: #005fa3;
}
.user-bulk-upload-modal .modal-content .bulk-container .btn.btn-primary.loading {
  opacity: 0.7;
  pointer-events: none;
}
.user-bulk-upload-modal .modal-content .bulk-container .btn.btn-secondary {
  background-color: #f3f4f6;
  color: #333;
}
.user-bulk-upload-modal .modal-content .bulk-container .btn.btn-secondary:hover {
  background-color: #e0e0e0;
}
.user-bulk-upload-modal .modal-content .bulk-container .btn.btn-outline {
  background: transparent;
  border: 1px solid #0077cc;
  color: #0077cc;
}
.user-bulk-upload-modal .modal-content .bulk-container .btn.btn-outline:hover {
  background: #0077cc;
  color: #fff;
}
.user-bulk-upload-modal .modal-content .bulk-container .file-upload {
  position: relative;
  overflow: hidden;
}
.user-bulk-upload-modal .modal-content .bulk-container .file-upload input[type=file] {
  position: absolute;
  inset: 0;
  opacity: 0;
  cursor: pointer;
}
.user-bulk-upload-modal .modal-content .bulk-container .file-name {
  font-weight: 500;
  color: #222;
  word-break: break-all;
}
.user-bulk-upload-modal .modal-content .bulk-container .info-banner {
  background: #e7f3ff;
  color: #084298;
  padding: 1rem;
  border-radius: 0.5rem;
  font-size: 0.95rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.user-bulk-upload-modal .modal-content .bulk-container .custom-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.95rem;
}
.user-bulk-upload-modal .modal-content .bulk-container .custom-table thead {
  background: #f8fafc;
}
.user-bulk-upload-modal .modal-content .bulk-container .custom-table thead th {
  text-align: left;
  padding: 0.8rem;
  color: #555;
  font-weight: 600;
}
.user-bulk-upload-modal .modal-content .bulk-container .custom-table tbody tr {
  border-bottom: 1px solid #eee;
}
.user-bulk-upload-modal .modal-content .bulk-container .custom-table tbody tr:hover {
  background: #f9fbfd;
}
.user-bulk-upload-modal .modal-content .bulk-container .custom-table tbody tr td {
  padding: 0.8rem;
  color: #333;
  vertical-align: middle;
}
.user-bulk-upload-modal .modal-content .bulk-container .custom-table .icon-btn {
  background: transparent;
  border: none;
  color: #d9534f;
  cursor: pointer;
  font-size: 1.1rem;
}
.user-bulk-upload-modal .modal-content .bulk-container .custom-table .icon-btn:hover {
  color: #c82333;
}
@media (max-width: 768px) {
  .user-bulk-upload-modal .modal-content .bulk-container {
    padding: 1rem;
  }
  .user-bulk-upload-modal .modal-content .bulk-container .upload-card,
  .user-bulk-upload-modal .modal-content .bulk-container .table-card {
    padding: 1.2rem;
  }
  .user-bulk-upload-modal .modal-content .bulk-container .custom-table {
    font-size: 0.85rem;
    display: block;
    overflow-x: auto;
    white-space: nowrap;
  }
  .user-bulk-upload-modal .modal-content .bulk-container .upload-actions,
  .user-bulk-upload-modal .modal-content .bulk-container .table-actions {
    justify-content: center;
  }
  .user-bulk-upload-modal .modal-content .bulk-container .section-title {
    font-size: 1.3rem;
  }
}
@media (max-width: 480px) {
  .user-bulk-upload-modal .modal-content .bulk-container .btn {
    width: 100%;
    text-align: center;
  }
  .user-bulk-upload-modal .modal-content .bulk-container .upload-actions,
  .user-bulk-upload-modal .modal-content .bulk-container .table-actions {
    flex-direction: column;
    align-items: stretch;
  }
}

/* 📱 Mobile responsiveness */
@media (max-width: 600px) {
  .user-bulk-upload-modal .modal-content {
    padding: 1rem;
    max-width: 95%;
  }
  .user-bulk-upload-modal .modal-content .upload-actions {
    flex-direction: column;
  }
  .user-bulk-upload-modal .modal-content .upload-actions button,
  .user-bulk-upload-modal .modal-content .upload-actions label {
    width: 100%;
  }
  .user-bulk-upload-modal .modal-content .custom-table th,
  .user-bulk-upload-modal .modal-content .custom-table td {
    font-size: 0.85rem;
    padding: 0.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/userandgroup/user/user.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,oBAAA;AAEF;;AACA;EACE,aAAA;EACA,yBAAA;EACA,iBAAA;EAkYA,eAAA;AA/XF;AADE;EACE,aAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;AAGJ;AADI;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;AAGN;AADM;EACE,WAAA;EACA,kCAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;AAGR;AADQ;EACE,qBAAA;EACA,4CAAA;EACA,aAAA;AAGV;AACM;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;AACR;AAGI;EACE,aAAA;EACA,eAAA;EACA,WAAA;AADN;AAGM;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;AADR;AAGQ;EACE,gBAAA;AADV;AAGU;EACE,mBAAA;EACA,WAAA;AADZ;AAKQ;EACE,gBAAA;AAHV;AAKU;EACE,mBAAA;EACA,WAAA;AAHZ;AAOQ;EACE,gBAAA;AALV;AAOU;EACE,mBAAA;EACA,WAAA;AALZ;AASQ;EACE,eAAA;AAPV;AAaE;EACE,gBAAA;AAXJ;AAcE;EACE,gBAAA;AAZJ;AAeE;EACE,gBAAA;EACA,mBAAA;EACA,yCAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;AAbJ;AAeI;EACE,WAAA;EACA,yBAAA;AAbN;AAeM;;EAEE,gBAAA;EACA,gBAAA;EACA,gCAAA;EACA,mBAAA;AAbR;AAgBM;EACE,mBAAA;AAdR;AAgBQ;EACE,gBAAA;EACA,iBAAA;EACA,WAAA;AAdV;AAmBQ;EACE,mBAAA;AAjBV;AAoBQ;EACE,kBAAA;EACA,WAAA;EACA,kBAAA;AAlBV;AAsBM;EACE,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AApBR;AAsBQ;EACE,mBAAA;EACA,cAAA;AApBV;AAuBQ;EACE,mBAAA;EACA,cAAA;AArBV;AAyBM;EACE,aAAA;EACA,WAAA;AAvBR;AAyBQ;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AAvBV;AAyBU;EACE,eAAA;AAvBZ;AA0BU;EACE,cAAA;AAxBZ;AA0BY;EACE,kCAAA;AAxBd;AA4BU;EACE,cAAA;AA1BZ;AA4BY;EACE,qCAAA;AA1Bd;AA8BU;EACE,cAAA;AA5BZ;AA8BY;EACE,mCAAA;AA5Bd;AA6IE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,wBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,yCAAA;EACA,gCAAA;AA3IJ;AA6II;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AA3IN;AA6IM;EACE,SAAA;EACA,gBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;AA3IR;AA8IM;EACE,aAAA;AA5IR;AA+IM;EACE,oBAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;AA7IR;AAgJM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;AA9IR;AAiJM;EACE,mBAAA;EACA,qBAAA;AA/IR;AAkJM;EACE,oDAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;AAhJR;AAmJM;EACE,YAAA;EACA,oBAAA;AAjJR;AAsJE;;;;EAIE,uBAAA;EACA,yBAAA;AApJJ;AAyJE;EACE;IACE,mBAAA;IACA,oBAAA;EAvJJ;EA0JE;IACE,8BAAA;EAxJJ;EA2JE;IACE,kBAAA;EAzJJ;EA4JE;IACE,iBAAA;EA1JJ;AACF;;AA8JA;EACE,WAAA;EACA,eAAA;EACA,sBAAA;EACA,qBAAA;EACA,oBAAA;AA3JF;AA6JE;EACE,qBAAA;EACA,6CAAA;EACA,aAAA;AA3JJ;;AA+JA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AA5JF;AA8JE;EACE,aAAA;AA5JJ;AA+JE;EACE,kBAAA;EACA,QAAA;EACA,8BAAA;AA7JJ;AAgKE;EACE,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,mBAAA;EACA,UAAA;EACA,gBAAA;EACA,0CAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;AA9JJ;AAgKI;EAdF;IAeI,UAAA;IACA,aAAA;EA7JJ;AACF;AAgKE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,6BAAA;EACA,sBAAA;EACA,QAAA;AA9JJ;AAgKI;EACE,iBAAA;EACA,gBAAA;AA9JN;AAiKI;EACE,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;AA/JN;AAiKM;EACE,WAAA;AA/JR;AAoKE;EACE,gBAAA;EACA,OAAA;EACA,gBAAA;AAlKJ;AAqKE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAnKJ;AAqKI;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,uBAAA;AAnKN;AAqKM;EACE,OAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAnKR;AAqKQ;EACE,gBAAA;EACA,cAAA;EACA,qBAAA;AAnKV;AAqKU;EACE,cAAA;AAnKZ;AAuKQ;;EAEE,WAAA;EACA,eAAA;EACA,sBAAA;EACA,qBAAA;EACA,oBAAA;AArKV;AAuKU;;EACE,qBAAA;EACA,6CAAA;EACA,aAAA;AApKZ;AAwKQ;EACE,cAAA;EACA,mBAAA;EACA,kBAAA;AAtKV;AA0KM;EACE,WAAA;AAxKR;AA4KI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AA1KN;AA4KM;EACE,kBAAA;EACA,kBAAA;AA1KR;AA4KQ;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,qBAAA;AA1KV;AA6KQ;EACE,aAAA;EACA,uBAAA;EACA,WAAA;AA3KV;AA6KU;EACE,eAAA;EACA,cAAA;EACA,eAAA;AA3KZ;AA8KU;EACE,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AA5KZ;AAmLE;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,0BAAA;EACA,mBAAA;AAjLJ;AAmLI;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;AAjLN;AAmLM;EACE,YAAA;EACA,mBAAA;AAjLR;AAoLM;EACE,yBAAA;AAlLR;AAsLI;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,sBAAA;EACA,eAAA;AApLN;AAsLM;EACE,yBAAA;AApLR;;AA0LA;EACE,eAAA;EACA,QAAA;EACA,8BAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAvLF;AAyLE;EACE,kBAAA;EACA,QAAA;AAvLJ;AA0LE;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,UAAA;EACA,aAAA;EACA,0CAAA;EACA,WAAA;EACA,6BAAA;EACA,YAAA;AAxLJ;AA0LI;EACE;IACE,UAAA;IACA,qBAAA;EAxLN;EA2LI;IACE,UAAA;IACA,mBAAA;EAzLN;AACF;AA4LI;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;EACA,2BAAA;AA1LN;AA4LM;EACE,WAAA;AA1LR;AA+LI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EA6KA,sBAAA;AAzWN;AA8LM;;EAEE,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,0CAAA;EACA,gCAAA;AA5LR;AA8LQ;;EACE,2BAAA;EACA,yCAAA;AA3LV;AA+LM;EACE,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,qBAAA;AA7LR;AAgMM;EACE,WAAA;EACA,mBAAA;AA9LR;AAiMM;EACE,gBAAA;EACA,oBAAA;EACA,WAAA;EACA,qBAAA;AA/LR;AAiMQ;EACE,qBAAA;AA/LV;AAkMQ;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AAhMV;AAkMU;EACE,0BAAA;AAhMZ;AAqMM;;EAEE,aAAA;EACA,eAAA;EACA,SAAA;EACA,yBAAA;EACA,kBAAA;AAnMR;AAsMM;EACE,YAAA;EACA,qBAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;AApMR;AAsMQ;EACE,yBAAA;EACA,WAAA;AApMV;AAsMU;EACE,yBAAA;AApMZ;AAuMU;EACE,YAAA;EACA,oBAAA;AArMZ;AAyMQ;EACE,yBAAA;EACA,WAAA;AAvMV;AAyMU;EACE,yBAAA;AAvMZ;AA2MQ;EACE,uBAAA;EACA,yBAAA;EACA,cAAA;AAzMV;AA2MU;EACE,mBAAA;EACA,WAAA;AAzMZ;AA8MM;EACE,kBAAA;EACA,gBAAA;AA5MR;AA8MQ;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;AA5MV;AAgNM;EACE,gBAAA;EACA,WAAA;EACA,qBAAA;AA9MR;AAiNM;EACE,mBAAA;EACA,cAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AA/MR;AAkNM;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;AAhNR;AAkNQ;EACE,mBAAA;AAhNV;AAkNU;EACE,gBAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;AAhNZ;AAoNQ;EACE,6BAAA;AAlNV;AAoNU;EACE,mBAAA;AAlNZ;AAqNU;EACE,eAAA;EACA,WAAA;EACA,sBAAA;AAnNZ;AAuNQ;EACE,uBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AArNV;AAuNU;EACE,cAAA;AArNZ;AA2NM;EApLF;IAqLI,aAAA;EAxNN;EA0NM;;IAEE,eAAA;EAxNR;EA2NM;IACE,kBAAA;IACA,cAAA;IACA,gBAAA;IACA,mBAAA;EAzNR;EA4NM;;IAEE,uBAAA;EA1NR;EA6NM;IACE,iBAAA;EA3NR;AACF;AA8NM;EACE;IACE,WAAA;IACA,kBAAA;EA5NR;EA+NM;;IAEE,sBAAA;IACA,oBAAA;EA7NR;AACF;;AAmOA,6BAAA;AACA;EAEI;IACE,aAAA;IACA,cAAA;EAjOJ;EAmOI;IACE,sBAAA;EAjON;EAmOM;;IAEE,WAAA;EAjOR;EAqOI;;IAEE,kBAAA;IACA,eAAA;EAnON;AACF","sourcesContent":[":host {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  align-items: stretch;\n}\n\n.user-section {\n  padding: 1rem;\n  background-color: #f9fafb;\n  min-height: 100vh;\n\n  .top-actions {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 1rem;\n    gap: 1rem;\n\n    .search-box {\n      position: relative;\n      flex: 1 1 250px;\n      max-width: 400px;\n\n      input {\n        width: 100%;\n        padding: 0.6rem 1rem 0.6rem 2.5rem;\n        border-radius: 10px;\n        border: 1px solid #ccc;\n        font-size: 0.95rem;\n        background: #fff;\n        transition: all 0.3s ease;\n\n        &:focus {\n          border-color: #1571b9;\n          box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);\n          outline: none;\n        }\n      }\n\n      .search-icon {\n        position: absolute;\n        left: 10px;\n        top: 50%;\n        transform: translateY(-50%);\n        color: #999;\n      }\n    }\n\n    .action-buttons {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 0.5rem;\n\n      .btn {\n        display: flex;\n        align-items: center;\n        gap: 0.4rem;\n        padding: 0.5rem 0.9rem;\n        border: none;\n        border-radius: 8px;\n        font-size: 0.9rem;\n        cursor: pointer;\n        color: #1571b9;\n        transition: all 0.3s ease;\n\n        &.primary {\n          background: #fff;\n\n          &:hover {\n            background: #1571b9;\n            color: #fff;\n          }\n        }\n\n        &.info {\n          background: #fff;\n\n          &:hover {\n            background: #1571b9;\n            color: #fff;\n          }\n        }\n\n        &.success {\n          background: #fff;\n\n          &:hover {\n            background: #1571b9;\n            color: #fff;\n          }\n        }\n\n        i {\n          font-size: 1rem;\n        }\n      }\n    }\n  }\n\n  .table-card {\n    overflow-x: auto;\n  }\n\n  .user-table {\n    min-width: 800px;\n  }\n\n  .table-card {\n    background: #fff;\n    border-radius: 12px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n    overflow-x: auto;\n    height: 70vh;\n    margin-bottom: 10px;\n\n    .user-table {\n      width: 100%;\n      border-collapse: collapse;\n\n      th,\n      td {\n        padding: 0.75rem;\n        text-align: left;\n        border-bottom: 1px solid #eaeaea;\n        white-space: nowrap;\n      }\n\n      thead {\n        background: #f1f3f5;\n\n        th {\n          font-weight: 600;\n          font-size: 0.9rem;\n          color: #333;\n        }\n      }\n\n      tbody {\n        tr:hover {\n          background: #f8f9fa;\n        }\n\n        .no-record {\n          text-align: center;\n          color: #888;\n          font-style: italic;\n        }\n      }\n\n      .status {\n        padding: 0.3rem 0.6rem;\n        border-radius: 8px;\n        font-size: 0.85rem;\n        font-weight: 500;\n\n        &.active {\n          background: #d4edda;\n          color: #155724;\n        }\n\n        &.inactive {\n          background: #f8d7da;\n          color: #721c24;\n        }\n      }\n\n      .actions {\n        display: flex;\n        gap: 0.4rem;\n\n        .icon-btn {\n          background: none;\n          border: none;\n          padding: 0.3rem;\n          border-radius: 6px;\n          cursor: pointer;\n          transition: all 0.3s ease;\n\n          i {\n            font-size: 1rem;\n          }\n\n          &.success {\n            color: #28a745;\n\n            &:hover {\n              background: rgba(40, 167, 69, 0.1);\n            }\n          }\n\n          &.warning {\n            color: #1571b9;\n\n            &:hover {\n              background: rgba(21, 114, 185, 0.212);\n            }\n          }\n\n          &.danger {\n            color: #dc3545;\n\n            &:hover {\n              background: rgba(220, 53, 69, 0.15);\n            }\n          }\n        }\n      }\n    }\n  }\n\n  // .pagination-container {\n  //   display: flex;\n  //   flex-wrap: wrap;\n  //   align-items: center;\n  //   justify-content: space-between;\n  //   padding: 0.75rem 1.25rem;\n  //   background: #ffffff;\n  //   border: 1px solid #e5e7eb;\n  //   border-radius: 12px;\n  //   box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\n  //   font-family: 'Inter', sans-serif;\n  //   transition: all 0.3s ease-in-out;\n\n  //   .pagination-info {\n  //     color: #374151;\n  //     font-size: 0.95rem;\n  //     font-weight: 500;\n\n  //     span {\n  //       background: #f3f4f6;\n  //       padding: 0.35rem 0.75rem;\n  //       border-radius: 8px;\n  //     }\n  //   }\n\n  //   .pagination-controls {\n  //     display: flex;\n  //     align-items: center;\n  //     justify-content: center;\n  //     line-height: 1;\n\n  //     ::ng-deep {\n  //       .ngx-pagination {\n  //         margin: 0;\n  //         // display: flex;\n  //         list-style: none;\n  //         padding: 0;\n\n  //         li {\n  //           // display: inline-flex;\n  //           align-items: center;\n  //           vertical-align: middle;\n  //           margin: 0 0.25rem;\n  //           height: 30px;\n  //           // display: inline-flex !important;\n\n  //           &.active a {\n  //             background: linear-gradient(90deg, #2563eb, #1d4ed8);\n  //             color: #fff !important;\n  //             border-color: transparent;\n  //           }\n\n  //           a {\n  //             display: flex;\n  //             align-items: center;\n  //             justify-content: center;\n  //             width: 35px;\n  //             height: 35px;\n  //             font-size: 0.9rem;\n  //             color: #374151;\n  //             background: #f9fafb;\n  //             border: 1px solid #d1d5db;\n  //             border-radius: 8px;\n  //             transition: all 0.2s ease-in-out;\n\n  //             &:hover {\n  //               background: #e5e7eb;\n  //               border-color: #9ca3af;\n  //             }\n  //           }\n\n  //           &.disabled a {\n  //             opacity: 0.5;\n  //             cursor: not-allowed;\n  //           }\n  //         }\n\n  //         .current span {\n  //           height: 25px;\n  //           display: flex;\n  //           align-items: center;\n  //         }\n  //       }\n  //     }\n  //   }\n\n  //   @media (max-width: 600px) {\n  //     flex-direction: column;\n  //     align-items: center;\n  //     gap: 0.75rem;\n\n  //     .pagination-info {\n  //       order: 2;\n  //     }\n\n  //     .pagination-controls {\n  //       order: 1;\n  //     }\n  //   }\n  // }\n\n  // .ngx-pagination li {\n  //   display: inline-flex !important;\n  // }\n\n  .pagination-container {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0.75rem 1.25rem;\n    background: #ffffff;\n    border: 1px solid #e5e7eb;\n    border-radius: 12px;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\n    font-family: 'Inter', sans-serif;\n\n    .pagination-controls {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      line-height: 1;\n\n      ::ng-deep .ngx-pagination {\n        margin: 0;\n        list-style: none;\n        padding: 0;\n        display: flex;\n        align-items: center;\n      }\n\n      ::ng-deep .ngx-pagination .small-screen{\n        display: none;\n      }\n\n      ::ng-deep .ngx-pagination li {\n        display: inline-flex;\n        align-items: center;\n        margin: 0 4px;\n        height: 35px;\n      }\n\n      ::ng-deep .ngx-pagination li a {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 35px;\n        height: 35px;\n        font-size: 0.9rem;\n        color: #374151;\n        background: #f9fafb;\n        border: 1px solid #d1d5db;\n        border-radius: 8px;\n        transition: all 0.2s ease;\n      }\n\n      ::ng-deep .ngx-pagination li a:hover {\n        background: #e5e7eb;\n        border-color: #9ca3af;\n      }\n\n      ::ng-deep .ngx-pagination .current {\n        background: linear-gradient(90deg, #2563eb, #1d4ed8);\n        color: #fff;\n        border-radius: 8px;\n        padding: 6px 12px;\n      }\n\n      ::ng-deep .ngx-pagination .disabled {\n        opacity: 0.5;\n        pointer-events: none;\n      }\n    }\n  }\n\n  ::ng-deep .pagination-previous,\n  ::ng-deep .pagination-next,\n  ::ng-deep .pagination-link,\n  ::ng-deep .pagination-ellipsis {\n    border: none !important;\n    padding-top: 0 !important;\n  }\n\n\n  /* Responsive */\n  @media (max-width: 768px) {\n    .top-actions {\n      flex-direction: row;\n      align-items: stretch;\n    }\n\n    .action-buttons {\n      justify-content: space-between;\n    }\n\n    .user-table {\n      font-size: 0.85rem;\n    }\n\n    .icon-btn i {\n      font-size: 0.9rem;\n    }\n  }\n}\n\ntextarea {\n  width: 100%;\n  padding: 0.6rem;\n  border: 1px solid #ccc;\n  border-radius: 0.5rem;\n  transition: all 0.3s;\n\n  &:focus {\n    border-color: #1571b9;\n    box-shadow: 0 0 0 2px rgba(50, 115, 220, 0.2);\n    outline: none;\n  }\n}\n\n.custom-modal {\n  position: fixed;\n  inset: 0;\n  display: none;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n\n  &.is-active {\n    display: flex;\n  }\n\n  .custom-modal-overlay {\n    position: absolute;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.6);\n  }\n\n  .custom-modal-container {\n    position: relative;\n    z-index: 2;\n    background: #fff;\n    border-radius: 1rem;\n    width: 90%;\n    max-width: 800px;\n    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);\n    overflow-y: auto;\n    max-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    padding: 1rem 1.5rem;\n\n    @media (max-width: 600px) {\n      width: 95%;\n      padding: 1rem;\n    }\n  }\n\n  .custom-modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-bottom: 1px solid #eee;\n    padding-bottom: 0.5rem;\n    order: 0;\n\n    h2 {\n      font-size: 1.3rem;\n      font-weight: 600;\n    }\n\n    .close-btn {\n      background: none;\n      border: none;\n      font-size: 1.2rem;\n      cursor: pointer;\n      color: #666;\n\n      &:hover {\n        color: #000;\n      }\n    }\n  }\n\n  .custom-modal-body {\n    margin-top: 1rem;\n    flex: 1;\n    overflow-y: auto;\n  }\n\n  .form-grid {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n\n    .input-row {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 1rem;\n      align-items: flex-start;\n\n      .input-group {\n        flex: 1;\n        min-width: 200px;\n        display: flex;\n        flex-direction: column;\n\n        label {\n          font-weight: 500;\n          display: block;\n          margin-bottom: 0.4rem;\n\n          span {\n            color: #ff4757;\n          }\n        }\n\n        input,\n        select {\n          width: 100%;\n          padding: 0.6rem;\n          border: 1px solid #ccc;\n          border-radius: 0.5rem;\n          transition: all 0.3s;\n\n          &:focus {\n            border-color: #1571b9;\n            box-shadow: 0 0 0 2px rgba(50, 115, 220, 0.2);\n            outline: none;\n          }\n        }\n\n        form-validation {\n          display: block;\n          margin-top: 0.25rem;\n          min-height: 1.2rem;\n        }\n      }\n\n      &.full-width {\n        width: 100%;\n      }\n    }\n\n    .profile-section {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n\n      .profile-wrapper {\n        position: relative;\n        text-align: center;\n\n        .profile-image {\n          width: 100px;\n          height: 100px;\n          border-radius: 50%;\n          object-fit: cover;\n          border: 2px solid #ddd;\n          margin-bottom: 0.5rem;\n        }\n\n        .profile-action {\n          display: flex;\n          justify-content: center;\n          gap: 0.5rem;\n\n          .file-label {\n            cursor: pointer;\n            color: #1571b9;\n            font-size: 1rem;\n          }\n\n          .remove-btn {\n            background: none;\n            border: none;\n            color: #ff4757;\n            cursor: pointer;\n            font-size: 0.9rem;\n          }\n        }\n      }\n    }\n  }\n\n  .custom-modal-footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 1rem;\n    border-top: 1px solid #eee;\n    padding-top: 0.8rem;\n\n    .primary-btn {\n      background-color: #1571b9;\n      color: #fff;\n      border: none;\n      border-radius: 0.5rem;\n      padding: 0.6rem 1.4rem;\n      cursor: pointer;\n      transition: 0.3s;\n\n      &:disabled {\n        opacity: 0.6;\n        cursor: not-allowed;\n      }\n\n      &:hover:not(:disabled) {\n        background-color: #1571b9;\n      }\n    }\n\n    .cancel-btn {\n      background-color: #f5f5f5;\n      color: #333;\n      border: none;\n      border-radius: 0.5rem;\n      padding: 0.6rem 1.4rem;\n      cursor: pointer;\n\n      &:hover {\n        background-color: #eaeaea;\n      }\n    }\n  }\n}\n\n.user-bulk-upload-modal {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 1050;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  .modal-overlay {\n    position: absolute;\n    inset: 0;\n  }\n\n  .modal-content {\n    position: relative;\n    background: #fff;\n    border-radius: 1rem;\n    max-width: 700px;\n    width: 90%;\n    padding: 2rem;\n    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n    z-index: 10;\n    animation: scaleIn 0.25s ease;\n    height: 70vh;\n\n    @keyframes scaleIn {\n      from {\n        opacity: 0;\n        transform: scale(0.9);\n      }\n\n      to {\n        opacity: 1;\n        transform: scale(1);\n      }\n    }\n\n    .close-btn {\n      position: absolute;\n      top: 1rem;\n      right: 1rem;\n      background: transparent;\n      border: none;\n      font-size: 1.2rem;\n      color: #666;\n      cursor: pointer;\n      transition: color 0.2s ease;\n\n      &:hover {\n        color: #000;\n      }\n    }\n\n    //------------------------------//\n    .bulk-container {\n      display: flex;\n      flex-direction: column;\n      gap: 2rem;\n      padding: 1.5rem;\n      max-width: 1000px;\n      margin: 0 auto;\n\n      .upload-card,\n      .table-card {\n        background: #fff;\n        border-radius: 1rem;\n        padding: 2rem;\n        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);\n        transition: all 0.3s ease-in-out;\n\n        &:hover {\n          transform: translateY(-3px);\n          box-shadow: 0 6px 18px rgba(0, 0, 0, 0.1);\n        }\n      }\n\n      .section-title {\n        font-size: 1.5rem;\n        font-weight: 600;\n        color: #333;\n        margin-bottom: 0.5rem;\n      }\n\n      .section-desc {\n        color: #666;\n        margin-bottom: 1rem;\n      }\n\n      .upload-guidelines {\n        list-style: disc;\n        padding-left: 1.5rem;\n        color: #555;\n        margin-bottom: 1.5rem;\n\n        li {\n          margin-bottom: 0.4rem;\n        }\n\n        .link {\n          color: #0077cc;\n          font-weight: 600;\n          cursor: pointer;\n\n          &:hover {\n            text-decoration: underline;\n          }\n        }\n      }\n\n      .upload-actions,\n      .table-actions {\n        display: flex;\n        flex-wrap: wrap;\n        gap: 1rem;\n        justify-content: flex-end;\n        margin-top: 1.5rem;\n      }\n\n      .btn {\n        border: none;\n        border-radius: 0.5rem;\n        padding: 0.6rem 1.2rem;\n        font-weight: 500;\n        cursor: pointer;\n        transition: all 0.25s ease;\n\n        &.btn-primary {\n          background-color: #0077cc;\n          color: #fff;\n\n          &:hover {\n            background-color: #005fa3;\n          }\n\n          &.loading {\n            opacity: 0.7;\n            pointer-events: none;\n          }\n        }\n\n        &.btn-secondary {\n          background-color: #f3f4f6;\n          color: #333;\n\n          &:hover {\n            background-color: #e0e0e0;\n          }\n        }\n\n        &.btn-outline {\n          background: transparent;\n          border: 1px solid #0077cc;\n          color: #0077cc;\n\n          &:hover {\n            background: #0077cc;\n            color: #fff;\n          }\n        }\n      }\n\n      .file-upload {\n        position: relative;\n        overflow: hidden;\n\n        input[type='file'] {\n          position: absolute;\n          inset: 0;\n          opacity: 0;\n          cursor: pointer;\n        }\n      }\n\n      .file-name {\n        font-weight: 500;\n        color: #222;\n        word-break: break-all;\n      }\n\n      .info-banner {\n        background: #e7f3ff;\n        color: #084298;\n        padding: 1rem;\n        border-radius: 0.5rem;\n        font-size: 0.95rem;\n        display: flex;\n        align-items: center;\n        gap: 0.5rem;\n      }\n\n      .custom-table {\n        width: 100%;\n        border-collapse: collapse;\n        font-size: 0.95rem;\n\n        thead {\n          background: #f8fafc;\n\n          th {\n            text-align: left;\n            padding: 0.8rem;\n            color: #555;\n            font-weight: 600;\n          }\n        }\n\n        tbody tr {\n          border-bottom: 1px solid #eee;\n\n          &:hover {\n            background: #f9fbfd;\n          }\n\n          td {\n            padding: 0.8rem;\n            color: #333;\n            vertical-align: middle;\n          }\n        }\n\n        .icon-btn {\n          background: transparent;\n          border: none;\n          color: #d9534f;\n          cursor: pointer;\n          font-size: 1.1rem;\n\n          &:hover {\n            color: #c82333;\n          }\n        }\n      }\n\n      /* Responsive Design */\n      @media (max-width: 768px) {\n        padding: 1rem;\n\n        .upload-card,\n        .table-card {\n          padding: 1.2rem;\n        }\n\n        .custom-table {\n          font-size: 0.85rem;\n          display: block;\n          overflow-x: auto;\n          white-space: nowrap;\n        }\n\n        .upload-actions,\n        .table-actions {\n          justify-content: center;\n        }\n\n        .section-title {\n          font-size: 1.3rem;\n        }\n      }\n\n      @media (max-width: 480px) {\n        .btn {\n          width: 100%;\n          text-align: center;\n        }\n\n        .upload-actions,\n        .table-actions {\n          flex-direction: column;\n          align-items: stretch;\n        }\n      }\n    }\n  }\n}\n\n/* 📱 Mobile responsiveness */\n@media (max-width: 600px) {\n  .user-bulk-upload-modal {\n    .modal-content {\n      padding: 1rem;\n      max-width: 95%;\n\n      .upload-actions {\n        flex-direction: column;\n\n        button,\n        label {\n          width: 100%;\n        }\n      }\n\n      .custom-table th,\n      .custom-table td {\n        font-size: 0.85rem;\n        padding: 0.5rem;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
